module.exports = __webpack_public_path__ + "static/media/site-admin-table.47458c00.png";